import {Component, inject, signal, type WritableSignal} from '@angular/core';
import {Button} from "primeng/button";
import {Navbar} from "../../../../shared/components/navbar/navbar";
import {TableUsers} from '../../../../shared/tables/table-users/table-users';
import { UserStatus} from '../../../../interfaces/user';
import {Router} from '@angular/router';
import {Card} from '../../../../shared/components/card/card/card';
import {CardHeader} from '../../../../shared/components/card/card-header/card-header';
import { UserService } from '../../../../services/user.service';
import { finalize } from 'rxjs';
import type { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Tooltip } from "primeng/tooltip";
import type { User } from '../../../../interfaces/user';

@Component({
  selector: 'app-users',
  imports: [
    Button,
    Navbar,
    TableUsers,
    Card,
    CardHeader,
    Tooltip
],
  templateUrl: './users.html',
  styleUrl: './users.css'
})
export class Users {
  private readonly _router: Router = inject(Router);
  private readonly _messageService: MessageService = inject(MessageService);
  private readonly _userService: UserService = inject(UserService);

  public user: WritableSignal<User|null> = signal<User|null>(null);

  public loading: WritableSignal<boolean> = signal<boolean>(false);

  public ngOnInit(): void {
    this._getUser();
  }

  private _toggleLoading(): void {
    this.loading.set(!this.loading());
  }

  private _getUser(): void {
    this._userService.me()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.user.set(response.data);
          }
        },
      })
  }

  public userHasPermission(permission: string): boolean {
    return this.user()?.roles.some(role => role.permissions.some(p => p.name === permission)) || false;
  }

  public routeToUser(userId?: string, readonly?: boolean): void {
    this._router.navigate(['users', userId || 'new'], { queryParams: { readonly } });
  }
  public disableUser(userId: string): void {
    this._toggleLoading();

    this._userService.put(userId, { status: UserStatus.INACTIVE })
      .pipe(finalize(() => this._toggleLoading()))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this._messageService.add({
              severity: 'success',
              summary: 'Usuário desativado',
              life: 3000
            });
          }
        },
        error: (error: HttpErrorResponse) => this._messageService.add({
          severity: 'error',
          summary: 'Falha ao desativar usuário',
          detail: error.error.message,
          life: 3000
        }),
      });
  }

  public enableUser(userId: string): void {
    this._toggleLoading();

    this._userService.put(userId, { status: UserStatus.ACTIVE })
      .pipe(finalize(() => this._toggleLoading()))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this._messageService.add({
              severity: 'success',
              summary: 'Usuário ativado',
              life: 3000
            });
          }
        },
        error: (error: HttpErrorResponse) => this._messageService.add({
          severity: 'error',
          summary: 'Falha ao desativar usuário',
          detail: error.error.message,
          life: 3000
        }),
      });
  }

  public deleteUser(userId: string): void {
    this._toggleLoading();

    this._userService.delete(userId)
      .pipe(finalize(() => this._toggleLoading()))
      .subscribe({
        next: () => {
          this._messageService.add({
            severity: 'success',
            summary: 'Usuário removido',
            life: 3000
          });
        },
        error: (error: HttpErrorResponse) => this._messageService.add({
          severity: 'error',
          summary: 'Falha ao deletar usuário',
          detail: error.error.message,
          life: 3000
        }),
      });
  }
}
